<div class="page">

  <!-- Header -->
  <div class="page-header">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Back
      </button>
      <div>
        <h1>New Admin</h1>
        <p>Create a new admin account</p>
      </div>
    </div>
  </div>

  <!-- Error -->
  <div class="error-msg" *ngIf="errorMessage">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    {{ errorMessage }}
  </div>

  <form class="form-card" (ngSubmit)="onSubmit()">
    <div class="form-section">
      <h2 class="section-title">Admin Details</h2>

      <div class="form-row">
        <div class="form-group">
          <label>Name <span class="required">*</span></label>
          <input type="text" [(ngModel)]="form.name" name="name" placeholder="e.g. Admin Name" />
        </div>
        <div class="form-group">
          <label>Email <span class="required">*</span></label>
          <input type="email" [(ngModel)]="form.email" name="email" placeholder="admin@jeeran.com" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Phone <span class="required">*</span></label>
          <input type="tel" [(ngModel)]="form.phone" name="phone" placeholder="+201234567890" />
        </div>
        <div class="form-group">
          <label>Password <span class="required">*</span></label>
          <div class="input-password-wrap">
            <input [type]="showPassword ? 'text' : 'password'"
              [(ngModel)]="form.password" name="password" placeholder="Admin@123" />
            <button type="button" class="btn-toggle-pw" (click)="showPassword = !showPassword">
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="form-divider"></div>

    <div class="form-actions">
      <button type="button" class="btn-secondary" (click)="goBack()">Cancel</button>
      <button type="submit" class="btn-primary" [disabled]="isSubmitting">
        <span *ngIf="!isSubmitting">Create Admin</span>
        <span *ngIf="isSubmitting" class="spinner-sm"></span>
      </button>
    </div>
  </form>

</div>
